import { APIResponse } from "../models/NetworkResponse";

import { deleteAPI, getAPI, postAPI, putAPI } from "./Networking";
import {
  OrderProductsVariantRequestSchema,
  OrderProductsVariantSchema,
} from "../models/Order/OrderProductsVariant";
export default class OrderProductsVariantsAPI {
  addVariant = async (
    orderId: number,
    variant: OrderProductsVariantRequestSchema,
  ): Promise<number> => {
    try {
      let url = `/v1/order-products-variants/order-id/${orderId}`;
      const response = await postAPI(url, { variant });
      return response.result.variant_id as number;
    } catch (error) {
      throw error;
    }
  };

  updateVariant = async (
    orderId: number,
    variantId: number,
    variant: OrderProductsVariantRequestSchema,
  ): Promise<number> => {
    try {
      let url = `/v1/order-products-variants/order-id/${orderId}/id/${variantId}`;
      const response = await putAPI(url, { variant });
      return response.result.variant_id as number;
    } catch (error) {
      throw error;
    }
  };

  fetchVariants = async (
    orderId: number,
    product_id: number,
  ): Promise<OrderProductsVariantSchema[]> => {
    try {
      let url = `/v1/order-products-variants/order-id/${orderId}/product-id/${product_id}`;
      const response = await getAPI(url);
      return response.result as OrderProductsVariantSchema[];
    } catch (error) {
      throw error;
    }
  };

  deleteVariant = async (
    orderId: number,
    variantId: number,
  ): Promise<number> => {
    try {
      let url = `/v1/order-products-variants/order-id/${orderId}/id/${variantId}`;
      const response = await deleteAPI(url);
      return response.result as number;
    } catch (error) {
      throw error;
    }
  };
}
